import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from './http-error.interceptor';
import { CacheInterceptor } from './cache.interceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';

/**
 * InterceptorsModule
 *
 * 提供全域 HTTP 攔截器的模組
 * 使用方式：在 AppModule 中匯入此模組
 */
@NgModule({
  imports: [
    MatSnackBarModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    }
  ]
})
export class InterceptorsModule { }
